export default __webpack_public_path__ + "locales/de/SharingPanel.json?hash=8f2689e5f8806a2cec33d9dc2982d868";